import { render, staticRenderFns } from "./Xqhz2.vue?vue&type=template&id=5895e428&scoped=true&"
import script from "./Xqhz2.vue?vue&type=script&lang=js&"
export * from "./Xqhz2.vue?vue&type=script&lang=js&"
import style0 from "./Xqhz2.vue?vue&type=style&index=0&id=5895e428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5895e428",
  null
  
)

export default component.exports